import React, { useState } from 'react';

export function DecimalInput({ value, onChange, className, placeholder = '0.00' }) {
  const [focused, setFocused] = useState(false);
  const [draft, setDraft] = useState('');

  const toNumber = (val) => {
    if (val === null || val === undefined || val === '') return 0;
    const n = parseFloat(val);
    return Number.isNaN(n) ? 0 : n;
  };

  const committedDisplay = toNumber(value).toFixed(2);

  return (
    <input
      type="text"
      inputMode="decimal"
      value={focused ? draft : committedDisplay}
      placeholder={placeholder}
      className={className}
      onFocus={(e) => {
        setDraft(committedDisplay);
        setFocused(true);
        requestAnimationFrame(() => e.target.select());
      }}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => {
        setFocused(false);
        const next = toNumber(draft).toFixed(2);
        if (next !== toNumber(value).toFixed(2)) {
          onChange(next);
        }
      }}
    />
  );
}

export function roundBillingMoney(value) {
  return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
}

export function laborScheduleBillingVsCost(schedules) {
  let billed = 0;
  let cost = 0;
  (schedules || []).forEach((row) => {
    const hours = parseFloat(row.hours) || 0;
    billed += hours * (parseFloat(row.billing_rate) || 0);
    cost += hours * (parseFloat(row.cost_rate) || 0);
  });
  billed = roundBillingMoney(billed);
  cost = roundBillingMoney(cost);
  return { billed, cost, markup: roundBillingMoney(billed - cost) };
}
